import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import useGlobalState from "../Context";

const Protected = ({
  isNormalUser,
  children,
  domainUser,
}) => {
  const [{ auth, isAllNotificateionRead },] = useGlobalState();
  const [notificationStatus, setNotificationStatus] = useState(
    isAllNotificateionRead
  );
  const [userType, setAuth] = useState(auth?.ldapParam?.userType);


  useEffect(() => {
    const loginUserType = auth?.ldapParam?.userType;
    setAuth(loginUserType);
    setNotificationStatus(isAllNotificateionRead);
  }, [isAllNotificateionRead, auth]);
  if (userType === "Main Admin") {
    return children;
  } else if (userType === "Domain Admin") {
    if ((isNormalUser || domainUser) && notificationStatus) {          
      return children;
    } else {
      return <Navigate to="/notifications" replace />;
    }
  } else if (userType === "Normal User") {
    if (notificationStatus && isNormalUser) {
      return children;
    } else {
      return <Navigate to="/notifications" replace />;
    }
  } else {
    return <Navigate to="/notifications" replace />;
  }
};
export default Protected;
